import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import _ from "lodash"
import Moment from "moment"

export default function FlightDealsCards(props) {

  const cardData = props.data.map((x, index) => {
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      cta: "Book Now",
      currencyCode: x.currency,
      discount: "",
      hidden: "",
      image: x.image?'https://static.stgairasia.com/seo/static-assets/SEOFlightsImages/medium/'+x.image:'https://s3.amazonaws.com/mmg-sites/aa_0144/img/medium/bangkok_region_6.jpg',
      imageAlt: `Flights from ${x.departure} to ${x.destination}`,
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: x.price,
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: "",
      productID: "",
      productType: "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: x.date,
      timer: "",
      title: x.departure+' to '+x.destination,
      url: `https://www.airasia.com/select/en/gb/${x.departurecode}/${x.destinationcode}/${Moment(x.date).format("YYYY-MM-DD")}/N/1/0/0/O/N/${x.currency}/ST`
    }
  })
  return (
    <Carousel
      accessible
      cardConfig={{
        focusEffect: true,
      }}
      data={[...cardData]}
      heading={{
        cardCount: "5",
        gtmParameters: {
          event: "trackEventNoEcommerce",
          eventActionClick: "click",
          eventActionView: "view",
          eventCategory: "{{consumername}} | Flight Promotion",
          eventLabelCardClick:
            "Flights Promotion | {{user}} | {{order}} | {{cardtitle}} | {{productid}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}",
          eventLabelHeadlineClick:
            "Flights Promotion | {{user}} | headline | {{headline}}",
          eventLabelView: "Flights Promotion | {{user}} | {{order}}",
        },
        headline: "",
        layoutName: "lob_widget",
        showMoreURL: "",
        subHeadline: "",
        widgetID: "",
        widgetName: "Flight Deal Widget",
        widgetWidth: "3",
      }}
      isLoading={_.isEmpty(props.data)}
      templateType="productCard"
      lazyLoadImage={true}
      enableProgressiveImageLoading={true}
    />
  )
}
